import data from "../../../../../packages/react/src/drafts/InlineAutocomplete/InlineAutocomplete.docs.json";
import * as React from 'react';
export default {
  data,
  React
};